import React, { useState } from "react";
import { Modal } from 'react-bootstrap';
import { Row, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import btnClose from "../../../assets/images/svg/close_modal_icon.svg";
import constants from "../../../constants/constants";

function ExtendServiceModal(props) {
    const [selectedCheckBox, setSelectedCheckBox] = useState(7);
    return (
        <>
            <Modal size="sm" show={props.show} onHide={props.handleClose} className="service-modal-content">
                <Modal.Header>
                    <Modal.Title>
                        انتخاب مدت تمدید سرویس
                        <img
                            onClick={props.handleClose}
                            src={btnClose}
                            className="btn-close"
                            size="sm"
                            alt=""
                        />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col sm={6}>
                                <Form.Check
                                    inline
                                    label={constants.ExtendDurationDays[1]}
                                    className="round form-check-rtl"
                                    type="radio"
                                    checked={selectedCheckBox === 14 ? true : false}
                                    onChange={() => {
                                        setSelectedCheckBox(14);
                                    }}
                                />

                            </Col>
                            <Col sm={6}>
                                <Form.Check
                                    inline
                                    label={constants.ExtendDurationDays[0]}
                                    className="round form-check-rtl"
                                    type="radio"
                                    checked={selectedCheckBox === 7 ? true : false}
                                    onChange={() => {
                                        setSelectedCheckBox(7);
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6}>
                                <Form.Check
                                    inline
                                    label={constants.ExtendDurationDays[3]}
                                    className="round form-check-rtl"
                                    type="radio"
                                    checked={selectedCheckBox === 30 ? true : false}
                                    onChange={() => {
                                        setSelectedCheckBox(30);
                                    }}
                                />

                            </Col>
                            <Col sm={6}>
                                <Form.Check
                                    inline
                                    label={constants.ExtendDurationDays[2]}
                                    className="round form-check-rtl"
                                    type="radio"
                                    checked={selectedCheckBox === 21 ? true : false}
                                    onChange={() => {
                                        setSelectedCheckBox(21);
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6}>
                                <Form.Check
                                    inline
                                    label={constants.ExtendDurationDays[5]}
                                    className="round form-check-rtl"
                                    type="radio"
                                    checked={selectedCheckBox === 90 ? true : false}
                                    onChange={() => {
                                        setSelectedCheckBox(90);
                                    }}
                                />

                            </Col>
                            <Col sm={6}>
                                <Form.Check
                                    inline
                                    label={constants.ExtendDurationDays[4]}
                                    className="round form-check-rtl"
                                    type="radio"
                                    checked={selectedCheckBox === 60 ? true : false}
                                    onChange={() => {
                                        setSelectedCheckBox(60);
                                    }}
                                />
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="confirm-button" variant="primary" onClick={(e) => props.handleExtendService(e, selectedCheckBox)}>
                        {constants.Extend}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default ExtendServiceModal;